import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
type ListItem = {
  [k: string]: {
    label: string;
    value: string;
  };
};
export const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const languageList: ListItem = {
  en: {
    label: '🇬🇧  English',
    value: 'en'
  },
  th: {
    label: '🇹🇭  Thai',
    value: 'th'
  },
  vi: {
    label: '🇻🇳  Vietnamese',
    value: 'vi'
  },
  ja: {
    label: '🇯🇵  Japanese',
    value: 'ja'
  }
};
export const areaUnitList: ListItem = {
  rai: {
    label: 'Rai (rai)',
    value: 'rai'
  },
  ha: {
    label: 'Hectare (ha)',
    value: 'ha'
  },
  m2: {
    label: 'Square Meters (m2)',
    value: 'm2'
  },
  '10a': {
    label: '10 Ares (10a)',
    value: '10a'
  },
  ac: {
    label: 'Acres (ac)',
    value: 'ac'
  }
};
export const weightUnitList: ListItem = {
  ton: {
    label: 'Ton (t)',
    value: 'ton'
  },
  kg: {
    label: 'Kilogram (kg)',
    value: 'kg'
  }
};
export const seedUnitList: ListItem = {
  bags: {
    label: 'Bags',
    value: 'bags'
  },
  kg: {
    label: 'Kilogram (kg)',
    value: 'kg'
  }
};
i18n.use(initReactI18next).use(Backend).init({
  // debug: isDevelopment,
  debug: false,
  fallbackLng: 'en',
  defaultNS: 'common',
  lng: 'en',
  ns: ['common', 'activityTypes', 'notifications'],
  react: {
    useSuspense: false
  },
  supportedLngs: ['en', 'th', 'vi', 'ja'],
  load: 'languageOnly',
  interpolation: {
    escapeValue: false
  },
  // https://github.com/i18next/react-i18next/issues/277
  backend: {
    loadPath: '/static/locales/{{lng}}/{{ns}}.json'
  }
});
export default i18n;